import React from 'react';
import Header from '../navbar/Header';
import Container from '../Container';
import Content from '../Content';
import Navbar from '../navbar/Navbar';
import ClientList from './ClientList';

function Client() {
    return ( 
        <Container>
            <Navbar/>

            <Content>
                <Header/>

             <ClientList/>
            </Content>
        </Container>
     );
}

export default Client;